<template>
  <transition name="contact-fade">
    <div v-if="contactsActive" class="fixed w-screen h-screen top-0 left-0 pt-5 flex flex-col overflow-y-scroll" style="background:rgba(50, 55, 73, 1);z-index: 600;">
      <header class="flex justify-between px-4.5 mb-7.5">
        <div class="max-agency flex flex-col relative z-10">
          <img src="@/assets/images/max-frai.svg" class="w-full" alt="" />
          <p
              class="uppercase inter font-bold mt-4 fz-10"
              style="color: #ff2e53; letter-spacing: 0.53rem; line-height: 1"
          >
            {{ text.first.AGENCY }}
          </p>
        </div>
        <div @click="toggleContacts" class="close ml-4.5 flex flex-col items-center w-max">
          <p class="uppercase font-medium fz-10 mb-4" style="line-height: 1 ;">{{ text.first.close }}</p>
          <div class="close relative w-5 h-5">
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 origin-center rotate-45 h-2px w-5 bg-white"></div>
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 origin-center -rotate-45 h-2px w-5 bg-white"></div>
          </div>
        </div>
      </header>
      <h2 class="uppercase fz-18 ml-4.5 font-medium mb-2.5" style="line-height:1.6666 ;">{{ text.first.decision }}</h2>
      <div class="relative ml-4.5">

        <transition name="form-first-fade">
          <contact-first @nextStage="services = $event; part = 2"  :text="text.first" v-if="part === 1"/>
        </transition>

        <transition name="form-second-fade">
          <contact-second :choice="services"  :text="text.second" @back="part = 1" v-if="part === 2"/>
        </transition>

      </div>
    </div>
  </transition>

</template>

<script>
import contactFirst from "@/components/mobile/contact/contactFirst";
import contactSecond from "@/components/mobile/contact/contactSecond";
import {mapMutations, mapState} from "vuex";

export default {
  name: "contact",
  components:{
    contactFirst,
    contactSecond
  },
  data(){
    return{
      part: 1,
      services:[]
    }
  },
  methods:{
    ...mapMutations(['toggleContacts'])
  },
  computed:{
    ...mapState(['lang', 'contactsActive']),
    text(){
      return require('@/assets/text/contact/' + this.lang + '.json')
    }
  }
}
</script>

<style scoped lang="scss">
.contact-fade-enter-active,
.contact-fade-leave-active,
.form-first-fade-enter-active,
.form-first-fade-leave-active,
.form-second-fade-enter-active,
.form-second-fade-leave-active{
  transition: all 0.3s ease;
  left: 0;
}
.form-first-fade-enter-from, .form-first-fade-leave-to{
  left: -100vw;
}
.contact-fade-enter-from, .contact-fade-leave-to,
.form-second-fade-enter-from, .form-second-fade-leave-to{
  left: 100vw;
}
</style>
